export const EmojiGood = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g clip-path="url(#clip0_5246_190113)">
      <g filter="url(#filter0_f_5246_190113)">
        <mask
          id="mask0_5246_190113"
          width="15"
          height="10"
          x="50"
          y="33"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M61.4 37.113c.99 2.428 1.364 3.841 3.445 5.114-.688-.086-2.402-.406-3.752-.998-1.687-.74-1.901-1.294-4.91-.067-3.01 1.226-5.023-.2-5.74-1.49-.849-1.527 1.437-5.523 4.696-6.005 2.587-.382 5.263 1.002 6.26 3.446Z"
          />
        </mask>
        <g mask="url(#mask0_5246_190113)">
          <path
            fill="#42AB44"
            d="M61.4 37.113c.99 2.428 1.364 3.841 3.445 5.114-.688-.086-2.402-.406-3.752-.998-1.687-.74-1.901-1.294-4.91-.067-3.01 1.226-5.023-.2-5.74-1.49-.849-1.527 1.437-5.523 4.696-6.005 2.587-.382 5.263 1.002 6.26 3.446Z"
          />
          <path
            fill="#050304"
            fill-rule="evenodd"
            d="M61.932 40.385c.255.315.505.583.75.766.86.64 1.661.97 2.126 1.161l.144.06.065-.154a18.902 18.902 0 0 0-.145-.06c-.464-.192-1.248-.514-2.09-1.141-.229-.17-.468-.426-.72-.737a25.348 25.348 0 0 1-.728-.96l-.069-.092c-.556-.757-1.172-1.583-1.871-2.185-1.406-1.212-3.352-1.352-4.455-1.005l.05.16c1.054-.333 2.938-.198 4.296.971.682.588 1.288 1.399 1.846 2.158l.069.093c.253.345.496.676.732.965Z"
            clip-rule="evenodd"
          />
          <path
            fill="#050304"
            d="M61.028 40.735c1.173.847 3.025 1.232 3.857 1.49l-.52 1.25c-1.884-.009-6.267.018-8.722.2-3.068.228-5.255-1.787-6.33-3.109-1.076-1.321-.377-2.692 1.081-4.307 1.458-1.616 1.955-2.156 2.676-2.504.768-.371 2.377-.53 3.37-.143-.462.128-.79.546-.867 1.4-.078.854 1.064 3.178 1.955 3.748 1.144.732 1.854.788 3.5 1.975Z"
          />
          <path
            fill="url(#paint0_linear_5246_190113)"
            d="M61.028 40.735c1.173.847 3.025 1.232 3.857 1.49l-.52 1.25c-1.884-.009-6.267.018-8.722.2-3.068.228-5.255-1.787-6.33-3.109-1.076-1.321-.377-2.692 1.081-4.307 1.458-1.616 1.955-2.156 2.676-2.504.768-.371 2.377-.53 3.37-.143-.462.128-.79.546-.867 1.4-.078.854 1.064 3.178 1.955 3.748 1.144.732 1.854.788 3.5 1.975Z"
          />
        </g>
        <path
          fill="#050304"
          fill-rule="evenodd"
          d="M55.024 36.853c-.748.027-2.859.486-5.78 2.034-1.493.791-3.156 2.14-4.614 3.483a47.28 47.28 0 0 0-3.482 3.568l.631.546a46.433 46.433 0 0 1 3.417-3.5c1.444-1.33 3.042-2.62 4.439-3.36 2.859-1.515 4.843-1.916 5.42-1.937l-.03-.834Z"
          clip-rule="evenodd"
        />
        <path
          fill="url(#paint1_linear_5246_190113)"
          fill-rule="evenodd"
          d="M55.024 36.853c-.748.027-2.859.486-5.78 2.034-1.493.791-3.156 2.14-4.614 3.483a47.28 47.28 0 0 0-3.482 3.568l.631.546a46.433 46.433 0 0 1 3.417-3.5c1.444-1.33 3.042-2.62 4.439-3.36 2.859-1.515 4.843-1.916 5.42-1.937l-.03-.834Z"
          clip-rule="evenodd"
        />
        <path
          fill="#050304"
          fill-rule="evenodd"
          d="M49.001 42.951c1.083-.127 2.145-.16 2.786-.025l-.17.817c-.5-.105-1.446-.088-2.519.037-1.06.124-2.18.347-3.008.621a17.1 17.1 0 0 0-4.356 2.177l-.473-.688a17.932 17.932 0 0 1 4.566-2.281c.898-.298 2.079-.53 3.174-.658Z"
          clip-rule="evenodd"
        />
        <mask
          id="mask1_5246_190113"
          width="14"
          height="14"
          x="49"
          y="42"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path
            fill="#fff"
            d="M58.476 43.759c-2.625-2.453-6.3-1.482-7.81-.69-.768 1.396-1.796 4.508.239 5.784 2.543 1.596 6.1 1.468 8.176 3.304 2.075 1.837 2.543 5.2 3.005 2.66.462-2.54-.328-7.991-3.61-11.058Z"
          />
        </mask>
        <g mask="url(#mask1_5246_190113)">
          <path
            fill="#42AB44"
            d="M58.476 43.759c-2.625-2.453-6.3-1.482-7.81-.69-.768 1.396-1.796 4.508.239 5.784 2.543 1.596 6.1 1.468 8.176 3.304 2.075 1.837 2.543 5.2 3.005 2.66.462-2.54-.328-7.991-3.61-11.058Z"
          />
          <path
            fill="#000"
            fill-rule="evenodd"
            d="M55.017 45.127c-1.05-.12-2.204-.253-3.484-1.034l.087-.143c1.247.761 2.363.89 3.413 1.01.17.02.34.04.508.062.597.078 1.177.189 1.74.46.566.27 1.11.699 1.643 1.407 1.436 1.91 1.916 3.465 2.155 4.892.078.464.13.917.181 1.362.028.235.054.467.084.697.088.67.205 1.333.438 2.02l-.158.053c-.239-.701-.357-1.377-.445-2.051a47.07 47.07 0 0 1-.085-.706c-.051-.442-.103-.887-.18-1.348-.235-1.404-.706-2.934-2.124-4.818-.518-.69-1.042-1.1-1.58-1.358-.54-.259-1.099-.367-1.691-.445-.165-.021-.332-.04-.502-.06Z"
            clip-rule="evenodd"
          />
          <path
            fill="#050304"
            d="M50.834 48.01c-.963-.822-1.1-2.112-1.049-2.654l-1.695 1.249.469 2.833 12.156 7.472 1.004-1.004c-.171-.78-.67-2.775-1.294-4.505-.781-2.163-2.721-2.99-4.438-3.057-1.718-.066-3.948.692-5.153-.334Z"
          />
          <path
            fill="url(#paint2_linear_5246_190113)"
            d="M50.834 48.01c-.963-.822-1.1-2.112-1.049-2.654l-1.695 1.249.469 2.833 12.156 7.472 1.004-1.004c-.171-.78-.67-2.775-1.294-4.505-.781-2.163-2.721-2.99-4.438-3.057-1.718-.066-3.948.692-5.153-.334Z"
          />
        </g>
      </g>
      <g filter="url(#filter1_f_5246_190113)">
        <path
          fill="#FFF0BC"
          d="M12.635 4.38a.563.563 0 0 1 .914-.422l2.466 1.968a.563.563 0 0 0 .554.085l2.602-1.004c.47-.182.924.3.714.759l-1.215 2.66a.563.563 0 0 0 .084.6L20.439 11a.563.563 0 0 1-.449.928l-3.09-.117a.563.563 0 0 0-.462.214l-1.915 2.427a.563.563 0 0 1-.998-.26l-.41-2.564a.563.563 0 0 0-.401-.452l-2.813-.802a.563.563 0 0 1-.114-1.036L12.24 8.01a.563.563 0 0 0 .295-.477l.101-3.154Z"
        />
      </g>
      <g filter="url(#filter2_f_5246_190113)">
        <path
          fill="#C2DEE4"
          d="M58.846 59.784c0-.07-.184-.139-.539-.205-3.277-.436-13.694-.75-26.035-.75-14.977 0-27.124.468-27.124 1.043 0 .07.184.14.539.205 3.289.436 13.694.751 26.035.751 14.977 0 27.124-.469 27.124-1.044Z"
        />
      </g>
      <mask
        id="mask2_5246_190113"
        width="45"
        height="45"
        x="10"
        y="7"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <circle cx="32.13" cy="29.281" r="21.984" fill="#fff" />
      </mask>
      <g mask="url(#mask2_5246_190113)">
        <circle cx="32.13" cy="29.281" r="21.984" fill="#D9D9D9" />
        <circle
          cx="32.13"
          cy="29.281"
          r="21.984"
          fill="url(#paint3_radial_5246_190113)"
        />
        <circle
          cx="32.13"
          cy="29.281"
          r="21.984"
          fill="url(#paint4_linear_5246_190113)"
        />
        <g filter="url(#filter3_f_5246_190113)">
          <path
            fill="#E9A700"
            d="m12.889 32.154 4.663 6.935 8.145-.517-5.672 6.295 3.009 7.086-7.974-2.846-6.999 4.764 1.126-7.616-7.076-4.662 8.013-1.552 2.765-7.887Z"
          />
        </g>
        <g filter="url(#filter4_f_5246_190113)">
          <ellipse
            cx="18.847"
            cy="31.757"
            fill="url(#paint5_radial_5246_190113)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter5_f_5246_190113)">
          <ellipse
            cx="43.804"
            cy="31.765"
            fill="url(#paint6_radial_5246_190113)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter6_f_5246_190113)">
          <path
            fill="#C73512"
            d="M44.652 46.053c5.556-4.304 6.744-8.576 7.57-14.549-1.768 7.06-4.959 10.322-9.546 13.638-5.287 3.822-9.88 4.374-17.658 3.659 6.82 1.74 13.781 1.787 19.634-2.748Z"
          />
        </g>
        <g filter="url(#filter7_ii_5246_190113)">
          <path
            stroke="#050304"
            stroke-linecap="round"
            stroke-width="1.68"
            d="M25.59 36.156s1.186 3.048 6.434 3.048 6.434-3.048 6.434-3.048"
          />
        </g>
        <g filter="url(#filter8_d_5246_190113)">
          <ellipse
            cx="42.445"
            cy="22.31"
            fill="url(#paint7_radial_5246_190113)"
            rx="7.804"
            ry="7.499"
            transform="rotate(20 42.445 22.31)"
          />
        </g>
        <ellipse
          cx=".743"
          cy="1.768"
          fill="#fff"
          rx=".743"
          ry="1.768"
          transform="matrix(.99947 -.03243 -.04057 .99918 47.975 20.75)"
        />
        <ellipse
          cx=".38"
          cy="1.005"
          fill="#fff"
          rx=".38"
          ry="1.005"
          transform="matrix(.85765 .51424 -.5875 .80923 47.79 25.266)"
        />
        <g filter="url(#filter9_d_5246_190113)">
          <ellipse
            cx="21.598"
            cy="22.316"
            fill="url(#paint8_radial_5246_190113)"
            rx="7.804"
            ry="7.5"
            transform="rotate(-20 21.598 22.316)"
          />
        </g>
        <ellipse
          cx=".743"
          cy="1.768"
          fill="#fff"
          rx=".743"
          ry="1.768"
          transform="matrix(.9992 .04018 -.1129 .9936 27.313 20.797)"
        />
        <ellipse
          cx=".38"
          cy="1.005"
          fill="#fff"
          rx=".38"
          ry="1.005"
          transform="matrix(.81807 .57513 -.6446 .76452 26.813 25.29)"
        />
      </g>
      <circle cx="42.5" cy="22.867" r="2.5" fill="#171A1C" />
      <circle cx="21.5" cy="22.867" r="2.5" fill="#171A1C" />
      <g filter="url(#filter10_ii_5246_190113)">
        <path
          fill="#fff"
          d="M10.151 35.796a1.2 1.2 0 0 1 2.129-.273l2.943 4.377a1.2 1.2 0 0 0 1.071.528l4.52-.286c1.073-.069 1.687 1.201.967 2l-3.19 3.54a1.2 1.2 0 0 0-.212 1.271l1.64 3.864c.409.962-.523 1.95-1.508 1.6l-4.822-1.722a1.2 1.2 0 0 0-1.078.138l-4.233 2.881c-.864.588-2.015-.133-1.862-1.167l.613-4.153a1.2 1.2 0 0 0-.526-1.177l-3.978-2.621c-.899-.592-.624-1.975.432-2.18l4.445-.861a1.2 1.2 0 0 0 .904-.782l1.745-4.977Z"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_5246_190113"
        width="25.617"
        height="24.053"
        x="40.188"
        y="32.642"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation=".48"
        />
      </filter>
      <filter
        id="filter1_f_5246_190113"
        width="13.335"
        height="13.079"
        x="8.367"
        y="2.71"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation=".563"
        />
      </filter>
      <filter
        id="filter2_f_5246_190113"
        width="56.27"
        height="4.573"
        x="3.862"
        y="57.542"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation=".643"
        />
      </filter>
      <filter
        id="filter3_f_5246_190113"
        width="28.088"
        height="26.213"
        x="-.14"
        y="29.905"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation="1.126"
        />
      </filter>
      <filter
        id="filter4_f_5246_190113"
        width="17.017"
        height="16.987"
        x="10.338"
        y="23.264"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter5_f_5246_190113"
        width="17.017"
        height="16.987"
        x="35.295"
        y="23.272"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter6_f_5246_190113"
        width="31.707"
        height="22.885"
        x="22.766"
        y="29.257"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190113"
          stdDeviation="1.126"
        />
      </filter>
      <filter
        id="filter7_ii_5246_190113"
        width="16.237"
        height="5.86"
        x="24.187"
        y="34.75"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy=".563" />
        <feGaussianBlur stdDeviation=".563" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190113" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.563" dy="-.563" />
        <feGaussianBlur stdDeviation=".563" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190113"
          result="effect2_innerShadow_5246_190113"
        />
      </filter>
      <filter
        id="filter8_d_5246_190113"
        width="25.673"
        height="25.201"
        x="30.734"
        y="11.397"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.970833 0 0 0 0 0.619202 0 0 0 0 0.533958 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190113"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190113"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_d_5246_190113"
        width="25.673"
        height="25.201"
        x="9.887"
        y="11.405"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.972549 0 0 0 0 0.619608 0 0 0 0 0.533333 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190113"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190113"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_ii_5246_190113"
        width="23.385"
        height="19.492"
        x=".958"
        y="34.429"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.126" />
        <feGaussianBlur stdDeviation="1.407" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.735556 0 0 0 0 0.0666667 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190113" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="2.251" dy="-.563" />
        <feGaussianBlur stdDeviation="1.688" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.972 0 0 0 0 1 0 0 0 0 0.8 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190113"
          result="effect2_innerShadow_5246_190113"
        />
      </filter>
      <radialGradient
        id="paint3_radial_5246_190113"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(43.657 -16.638 42.45) scale(32.7647 30.6393)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEFFCF" />
        <stop offset=".418" stop-color="#FFCA42" />
        <stop offset=".736" stop-color="#FFCF53" />
        <stop offset="1" stop-color="#FF8163" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_5246_190113"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 18.847 31.757)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#FCC" />
        <stop offset="1" stop-color="#FCC" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_5246_190113"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 43.804 31.765)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#FCC" />
        <stop offset="1" stop-color="#FCC" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_5246_190113"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(9.20429 -4.68031 4.23345 8.3255 40.592 22.916)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_5246_190113"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(7.0807 6.99348 -6.32575 6.40465 20.423 20.469)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <linearGradient
        id="paint0_linear_5246_190113"
        x1="50.258"
        x2="55.201"
        y1="39.156"
        y2="38.395"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0057D6" />
        <stop offset="1" stop-color="#0057D6" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5246_190113"
        x1="43.516"
        x2="48.253"
        y1="43.283"
        y2="39.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0057D6" />
        <stop offset="1" stop-color="#0057D6" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5246_190113"
        x1="61.024"
        x2="55.022"
        y1="55.437"
        y2="48.873"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0057D6" />
        <stop offset="1" stop-color="#0057D6" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5246_190113"
        x1="21.677"
        x2="35.265"
        y1="9.48"
        y2="28.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#FEFFCF" />
        <stop offset=".353" stop-color="#FEFFCF" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_5246_190113">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);
